(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["studio-how-it-works"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.studioReady) return;
      root.dataset.studioReady = '1';
      var steps = Array.prototype.slice.call(root.querySelectorAll('.studio-steps__step'));
      var panels = Array.prototype.slice.call(root.querySelectorAll('.studio-steps__panel'));
      if (!steps.length) return;
      var active = 0;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function setActive(i) {
        active = (i + steps.length) % steps.length;
        steps.forEach(function (s, idx) {
          var on = idx === active;
          s.classList.toggle('is-active', on);
          s.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (p, idx) { p.classList.toggle('is-active', idx === active); });
        var bar = steps[active].querySelector('.studio-steps__bar');
        if (bar) { bar.style.animation = 'none'; void bar.offsetWidth; bar.style.animation = ''; }
      }

      root.addEventListener('animationend', function (e) {
        if (e.animationName === 'studioStepsFill') setActive(active + 1);
      });
      steps.forEach(function (s, idx) {
        s.addEventListener('click', function () { setActive(idx); });
      });

      setActive(0);
      // Reduced-motion / no-animation fallback: rotate on a timer
      if (reduce) {
        setInterval(function () { setActive(active + 1); }, 6000);
      }
    }

    function boot() { document.querySelectorAll('.studio-steps').forEach(init); }
    if (document.readyState !== 'loading') boot();
    else document.addEventListener('DOMContentLoaded', boot);
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();
})();
